import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from 'seagull/components/Grid';
import { Typography } from 'seagull/components/Typography';
import { Clock } from 'seagull/icons';
import { ContactDetails } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/ContactDetails/ContactDetails';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getUICompanyName } from '../EditDraftsTable.utils';
import { useGetDraftContact } from '../hooks/useGetDraftContact';
import styles from './Cells.module.scss';
import { draftAfterContactChange } from './ContactCell.utils';
function EditContactModalContent(props) {
    const { draft, setDraft } = props;
    const { refresh } = useContacts();
    const contact = useGetDraftContact(draft);
    return /*#__PURE__*/ _jsx(Grid, {
        align: "center",
        children: /*#__PURE__*/ _jsx(ContactDetails, {
            existingContact: contact || undefined,
            showCustomerDetailsWarning: false,
            refreshExistingContacts: refresh,
            onChange: (change)=>{
                const next = draftAfterContactChange(draft, change);
                if (next != null) setDraft(next);
            }
        })
    });
}
export function ContactCell(param) {
    let { draft, index, onOpenModal, getContact, isDisabled, disabledTooltip } = param;
    const contact = getContact(draft);
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const companyName = getUICompanyName(draft, contact, editTableTexts.anchorSample());
    const scheduledDate = draft.scheduledDate();
    const renderContactModal = (param)=>{
        let { draft, setDraft } = param;
        return {
            title: draftCellsTexts.primaryContact(),
            testId: "edit-contact-modal",
            onSubmit: (defaultBehavior)=>{
                defaultBehavior();
            },
            content: /*#__PURE__*/ _jsx(EditContactModalContent, {
                draft: draft,
                setDraft: setDraft
            })
        };
    };
    const onClick = ()=>onOpenModal({
            renderContent: renderContactModal
        });
    return /*#__PURE__*/ _jsxs(EditableTableCell, {
        testId: "edit-contact-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.scheduledTooltip,
                children: [
                    companyName && /*#__PURE__*/ _jsx(Typography, {
                        ellipsis: true,
                        weight: "normal",
                        testId: "company-name-".concat(index),
                        children: companyName
                    }),
                    scheduledDate && /*#__PURE__*/ _jsx("div", {
                        "data-testid": "scheduled-tooltip-icon-".concat(index),
                        children: /*#__PURE__*/ _jsx(Clock, {
                            size: 16
                        })
                    })
                ]
            }),
            contact && /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                variant: "paragraph2",
                skin: "secondary",
                testId: "contact-name-".concat(index),
                children: "".concat(contact.firstName(), " ").concat(contact.lastName(), " (").concat(contact.email(), ")")
            }),
            !companyName && !contact && /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                skin: "secondary",
                children: "Not set"
            })
        ]
    });
}
